/* Tempo Kicks - tint the product title and description headings
   with the dominant colour of the shoe (read from the featured image, window.tempoImage).
   White / black / grey shoes keep the default black title. Buttons always keep the fixed theme colours. */
(function () {
  'use strict';
  if (window.tempoFixedColors) return; // colours already set server-side from the product metafield
  if (!/\/products\//.test(location.pathname) || !window.tempoImage) return;

  function rgbToHsl(r, g, b) {
    r /= 255; g /= 255; b /= 255;
    var max = Math.max(r, g, b), min = Math.min(r, g, b), h = 0, s = 0, l = (max + min) / 2;
    if (max !== min) {
      var d = max - min;
      s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
      if (max === r) h = (g - b) / d + (g < b ? 6 : 0);
      else if (max === g) h = (b - r) / d + 2;
      else h = (r - g) / d + 4;
      h /= 6;
    }
    return [h, s, l];
  }
  function css(h, s, l) { return 'hsl(' + Math.round(h * 360) + ',' + Math.round(s * 100) + '%,' + Math.round(l * 100) + '%)'; }
  function clampL(l, lo, hi) { return Math.min(hi, Math.max(lo, l)); }

  // returns up to 2 dominant colours as [{h,s,l}], strongest first, or [] for neutral shoes
  function dominant(img) {
    var w = 80, h = 80, c = document.createElement('canvas');
    c.width = w; c.height = h;
    var ctx = c.getContext('2d');
    ctx.drawImage(img, 0, 0, w, h);
    var data;
    try { data = ctx.getImageData(0, 0, w, h).data; } catch (e) { return []; }
    // two bucket maps: "strict" (vivid colours only) picks the 1st colour,
    // "soft" also keeps muted / dark tones (brown, khaki, navy...) for the 2nd colour
    var strict = {}, soft = {}, total = 0;
    function add(map, hsl) {
      var key = Math.floor(hsl[0] * 24);
      var b = map[key] || (map[key] = { key: key, n: 0, h: 0, s: 0, l: 0 });
      b.n++; b.h += hsl[0]; b.s += hsl[1]; b.l += hsl[2];
    }
    for (var i = 0; i < data.length; i += 4) {
      if (data[i + 3] < 200) continue;
      var hsl = rgbToHsl(data[i], data[i + 1], data[i + 2]);
      total++;
      // skip white, black and grey pixels (background + neutral parts of the shoe)
      if (hsl[1] < 0.12 || hsl[2] < 0.08 || hsl[2] > 0.85) continue;
      add(soft, hsl);
      if (hsl[1] >= 0.3 && hsl[2] >= 0.12 && hsl[2] <= 0.88) add(strict, hsl);
    }
    function sorted(map) {
      var list = [];
      for (var k in map) list.push(map[k]);
      list.sort(function (a, b) { return b.n - a.n; });
      return list;
    }
    function hueDist(a, b) { var d = Math.abs(a - b); return Math.min(d, 1 - d); }
    var out = [];
    var s1 = sorted(strict);
    if (!s1.length || s1[0].n < total * 0.03) return out; // neutral shoe: 1st colour needs ~3% of the picture
    out.push({ h: s1[0].h / s1[0].n, s: Math.min(0.9, s1[0].s / s1[0].n), l: s1[0].l / s1[0].n });
    // second colour: strongest clearly different hue (>= 45 deg), muted tones allowed, ~1% of the picture
    var s2 = sorted(soft);
    for (var j = 0; j < s2.length; j++) {
      var b2 = s2[j];
      if (b2.n < total * 0.01) break;
      var hue = b2.h / b2.n;
      if (hueDist(hue, out[0].h) < 0.125) continue;
      out.push({ h: hue, s: Math.min(0.9, Math.max(0.35, b2.s / b2.n)), l: b2.l / b2.n }); // muted tones get a little boost so the button still reads as a colour
      break;
    }
    return out;
  }

  function apply(cols) {
    var c1 = cols[0];
    var text = css(c1.h, c1.s, clampL(c1.l, 0.28, 0.42));       // dark enough to read on white
    var st = document.createElement('style');
    st.textContent =
      '.product-info-heading,.product-info-main h1,.product-info h1,.product-title,h1.product-title{color:' + text + '!important}' +
      '.product-info-description h2,.product-info-details h2,.product-description h2,.rte h2{color:' + text + '!important}' +
      '.product-info-description strong,.product-description strong,.rte strong{color:' + text + '}';
    // buttons keep the fixed theme colours (blue / red) for conversion
    document.head.appendChild(st);
  }

  var img = new Image();
  img.crossOrigin = 'anonymous';
  img.onload = function () { var c = dominant(img); if (c.length) apply(c); };
  img.src = window.tempoImage;
})();
